import {WorkrequestViewmodelBase} from '../../shared/viewmodels/workrequest-viewmodel-base';
import {WorkrequestCmpDetails} from './workrequest-cmp-details';

export class WorkrequestCmpViewmodel extends WorkrequestViewmodelBase {
  applicationFeeAmount: number;

  errorMessage: string;
  detailedDescription: string;

  constructor() {
    super();
    this.workrequestDetails = new WorkrequestCmpDetails();
    this.errorMessage = null;
  }

  get serviceTappingSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingSelected;
  }

  set serviceTappingSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingSize =
        (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingFlow =
          (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingQty = null;
    }
  }

  get serviceTappingSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingSize;
  }

  set serviceTappingSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingSize = v;
    if (v > 0) {
      this.serviceTappingSelected = true;
    }
  }

  get serviceTappingFlow(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingFlow;
  }

  set serviceTappingFlow(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingFlow = v;
    if (v > 0) {
      this.serviceTappingSelected = true;
    }
  }

  get serviceTappingQty(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingQty;
  }

  set serviceTappingQty(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).serviceTappingQty = v;
    if (v > 0) {
      this.serviceTappingSelected = true;
    }
  }

  // get fireServiceSelected(): boolean {
  //   return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSelected;
  // }

  // set fireServiceSelected(v: boolean) {
  //   (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSelected = v;
  //   if (!v) {
  //     (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSize =
  //       (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceFlow =
  //         (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceQty = null;
  //   }
  // }

  // get fireServiceSize(): number {
  //   return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSize;
  // }

  // set fireServiceSize(v: number) {
  //   (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceSize = v;
  //   if (v > 0) {
  //     this.fireServiceSelected = true;
  //   }
  // }

  // get fireServiceFlow(): number {
  //   return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceFlow;
  // }

  // set fireServiceFlow(v: number) {
  //   (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceFlow = v;
  //   if (v > 0) {
  //     this.fireServiceSelected = true;
  //   }
  // }

  // get fireServiceQty(): number {
  //   return (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceQty;
  // }

  // set fireServiceQty(v: number) {
  //   (<WorkrequestCmpDetails>this.workrequestDetails).fireServiceQty = v;
  //   if (v > 0) {
  //     this.fireServiceSelected = true;
  //   }
  // }

  get mainMeterSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterSelected;
  }

  set mainMeterSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterSize =
        (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterFlow =
          (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterQty = null;
    }
  }

  get mainMeterSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterSize;
  }

  set mainMeterSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterSize = v;
    if (v > 0) {
      this.mainMeterSelected = true;
    }
  }

  get mainMeterFlow(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterFlow;
  }

  set mainMeterFlow(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterFlow = v;
    if (v > 0) {
      this.mainMeterSelected = true;
    }
  }

  get mainMeterQty(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterQty;
  }

  set mainMeterQty(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).mainMeterQty = v;
    if (v > 0) {
      this.mainMeterSelected = true;
    }
  }

  get checkMeterRSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRSelected;
  }

  set checkMeterRSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRSize = null;
    }
  }

  get checkMeterRSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRSize;
  }

  set checkMeterRSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRSize = v;
    if (v > 0) {
      this.checkMeterRSelected = true;
    }
  }

  get checkMeterRQty(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRQty;
  }

  set checkMeterRQty(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterRQty = v;
    if (v > 0) {
      this.checkMeterRSelected = true;
    }
  }

  get checkMeterCSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCSelected;
  }

  set checkMeterCSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCSize = null;
    }
  }

  get checkMeterCSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCSize;
  }

  get checkMeterCQty(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCQty;
  }

  set checkMeterCQty(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCQty = v;
    if (v > 0) {
      this.checkMeterCSelected = true;
    }
  }

  set checkMeterCSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).checkMeterCSize = v;
    if (v > 0) {
      this.checkMeterCSelected = true;
    }
  }

  get existingServiceSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).existingServiceSelected;
  }

  set existingServiceSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).existingServiceSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).existingServiceDetails = null;
    }
  }

  get existingServiceDetails(): string {
    return (<WorkrequestCmpDetails>this.workrequestDetails).existingServiceDetails;
  }

  set existingServiceDetails(v: string) {
    (<WorkrequestCmpDetails>this.workrequestDetails).existingServiceDetails = v;
    if (v) {
      this.existingServiceSelected = true;
    }
  }

  get existingMeterNumbersSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).existingMeterNumbersSelected;
  }

  set existingMeterNumbersSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).existingMeterNumbersSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).existingMeterNumbers = null;
    }
  }

  get existingMeterNumbers(): string {
    return (<WorkrequestCmpDetails>this.workrequestDetails).existingMeterNumbers;
  }

  set existingMeterNumbers(v: string) {
    (<WorkrequestCmpDetails>this.workrequestDetails).existingMeterNumbers = v;
    if (!!v) {
      this.existingMeterNumbersSelected = true;
    }
  }

  get recycledTappingSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingSelected;
  }

  set recycledTappingSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingSize =
        (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingFlow =
          (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingQty = null;
    }
  }

  get recycledTappingSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingSize;
  }

  set recycledTappingSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingSize = v;
    if (v > 0) {
      this.recycledTappingSelected = true;
    }
  }

  get recycledTappingFlow(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingFlow;
  }

  set recycledTappingFlow(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingFlow = v;
    if (v > 0) {
      this.recycledTappingSelected = true;
    }
  }

  get recycledTappingQty(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingQty;
  }

  set recycledTappingQty(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledTappingQty = v;
    if (v > 0) {
      this.recycledTappingSelected = true;
    }
  }

  get recycledMainMeterSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledMainMeterSelected;
  }

  set recycledMainMeterSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledMainMeterSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).recycledMainMeterSize = null;
    }
  }

  get recycledMainMeterSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledMainMeterSize;
  }

  set recycledMainMeterSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledMainMeterSize = v;
    if (v > 0) {
      this.recycledMainMeterSelected = true;
    }
  }

  get recycledCheckMeterRSelected(): boolean {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledCheckMeterRSelected;
  }

  set recycledCheckMeterRSelected(v: boolean) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledCheckMeterRSelected = v;
    if (!v) {
      (<WorkrequestCmpDetails>this.workrequestDetails).recycledCheckMeterRSize = null;
    }
  }

  get recycledCheckMeterRSize(): number {
    return (<WorkrequestCmpDetails>this.workrequestDetails).recycledCheckMeterRSize;
  }

  set recycledCheckMeterRSize(v: number) {
    (<WorkrequestCmpDetails>this.workrequestDetails).recycledCheckMeterRSize = v;
    if (v > 0) {
      this.recycledCheckMeterRSelected = true;
    }
  }

  get propertyOnCombinedDrain(): string {
    return (<WorkrequestCmpDetails>this.workrequestDetails).propertyOnCombinedDrain;
  }

  set propertyOnCombinedDrain(v: string) {
    (<WorkrequestCmpDetails>this.workrequestDetails).propertyOnCombinedDrain = v;
    
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/workrequest-cmp-viewmodel.ts